import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from '@material-ui/core';
import { ExpandMore, Add } from '@material-ui/icons';
import { useStyles } from './styles';
import VehicleForm from './VehicleForm';
import { generateId } from '../../pages/AddEngineering/utils';
import { VehicleObject } from '../../@types/incidentTypes';

const initialVehicle: VehicleObject = {
  index: 0,
  Categoria: 'Não informado',
  Cor: '',
  'Código Veículo': '',
  Espécie: 'Não informado',
  Manobra: '',
  Danificado: 'Não informado',
  'Tipo Veículo': 'Não informado',
  Aluguel: 'Não informado',
  Marca: '',
  'Número do Ônibus': '',
  Placa: '',
  'Ano Fabricação': '',
  Legalizado: 'Não informado',
  _localId: '',
  'Linha do Ônibus': '',
  'Outra manobra': '',
  'Via de Acesso': 'Não informado',
};

interface IProps {
  driverVehicles: VehicleObject[];
  setDriverVehicles: React.Dispatch<React.SetStateAction<VehicleObject[]>>;
  viaNames: string[];
  desabilitado?: boolean;
}

const VehicleFormGroup: React.FC<IProps> = ({
  setDriverVehicles,
  driverVehicles,
  viaNames,
  desabilitado,
}) => {
  const classes = useStyles();

  const addNewVehicle = () => {
    const list = driverVehicles;
    list.push({
      ...initialVehicle,
      index: driverVehicles.length,
      _localId: generateId(),
      'Código Veículo': `.${driverVehicles.length + 1}`,
    });
    setDriverVehicles([...list]);
  };

  const deleteVehicle = (index: number) => {
    const list = driverVehicles
      .filter((item) => {
        return item.index !== index;
      })
      .map((item, i) => {
        return { ...item, index: i };
      });
    setDriverVehicles([...list]);
  };

  const changeVehiclesState = (vehicle: VehicleObject) => {
    const list = driverVehicles;
    list[vehicle.index] = vehicle;
    setDriverVehicles([...list]);
  };

  return (
    <Accordion className={classes.accordionContainer}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Veículos</Typography>{' '}
      </AccordionSummary>
      <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <div className={classes.addButtonContainer}>
            <Button
              color="default"
              variant="outlined"
              endIcon={<Add />}
              className={classes.addButton}
              onClick={() => addNewVehicle()}
              disabled={desabilitado}
            >
              Adicionar
            </Button>
          </div>

          {driverVehicles.map((item) => {
            return (
              <VehicleForm
                key={item._localId}
                vehicleObject={item}
                deleteVehicle={deleteVehicle}
                changeVehiclesState={changeVehiclesState}
                viaNames={viaNames}
                desabilitadoVehicleForm={desabilitado}
              />
            );
          })}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default VehicleFormGroup;
